<content *ngIf="fieldData && fieldConfig">
  <div class="eidos-field" [innerHTML]="fieldData[fieldConfig.name] | safeHtml"></div>
</content>
